import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

console.log(API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
     if (error.response?.status === 403 && error.response?.data?.planExpired) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      alert(error.response.data.message || 'Your subscription plan has expired. Please renew your plan to continue.');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    // Check if vendor's plan has expired (403 with planExpired flag)
    if (error.response?.status === 403 && error.response?.data?.requiresAction === 'super_admin_approval') {
      alert(error.response.data.message);
      return Promise.reject(error);
    }
    
    // Only redirect on 401 if user is already logged in (has token)
    // Don't redirect during login attempts
    if (error.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
